import { Component, OnInit } from '@angular/core';
import { GassClaims } from 'src/app/auth/gass-claims';
import { IdentityService } from 'src/app/auth/identity.service';
import { DocumentiService } from 'src/app/core/documenti.service';
import { DocumentiListColumnNames } from 'src/app/shared/components/documenti-list/documenti-list.model';
import { DocumentiSearchRequest, DocumentiSearchResponse } from 'src/app/shared/models/documento-search.model';
import { StatiPredefiniti } from 'src/app/shared/models/stati-predefiniti';

@Component({
  selector: 'app-evidenze',
  template: `
    <ng-container *hasClaim="GassClaims.DocConsultazione">
      <div class="card card-w-title">
        <h1>Elenco evidenze</h1>
        <app-documenti-list *ngIf="searchResponse?.results" (updateRequestAndSearch)="updateRequestAndSearch($event)"
          [data]="searchResponse" [activeColumns]="columns" [showEvidenzaButtons]="true">
        </app-documenti-list>
      </div>
    <ng-container>
    &nbsp;
  `
})
export class EvidenzeComponent implements OnInit {
  public GassClaims = GassClaims;
  public columns: DocumentiListColumnNames = ['Protocollo', 'DataDocumento', 'PosizioneId', 'DataScadenza', 'StatoUtente', 'Oggetto', 'ActionButtons'];

  public searchResponse = {
    originalRequest: {
      pageFirstRow: 0, pageSize: 20,
      sortField: 'DataScadenza', sortOrder: 1,
      filters: { statoId: StatiPredefiniti.Evidenza }
    }
  } as DocumentiSearchResponse;

  constructor(
    private documentiService: DocumentiService,
    private identityService: IdentityService
  ) { }

  ngOnInit(): void {
    if (this.identityService.hasClaim(GassClaims.DocConsultazione)) {
      this.updateRequestAndSearch(null);
    }
  }

  updateRequestAndSearch(request: DocumentiSearchRequest | null): void {
    const mergedRequest = { ...this.searchResponse.originalRequest, ...request } as DocumentiSearchRequest;
    this.documentiService.search(mergedRequest).subscribe(response => this.searchResponse = response);
  }
}
